/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  console.log("getting cart..")
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.minicart-product-list');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback){
  console.log("add item runs...");
  console.log(variant_id,"variant_id...")
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
  console.log("add item from form...");

  var formData = jQuery('#' + form_id).serializeArray(); 

  var variant2_id = localStorage.getItem("variant2Id");
  var option_name = localStorage.getItem("optionName");
  var restricted = localStorage.getItem("restricted");

  function updateFormData(formData, fieldName, newValue) {
    console.log(fieldName,newValue,"formdata item to push");
    for (var i = 0; i < formData.length; i++) {
        if (formData[i].name === fieldName) {
            formData[i].value = newValue; 
            return; 
        }
    }

    formData.push({ name: fieldName, value: newValue });
}
  console.log("restricted>>",restricted)
  if(restricted == 'true'){
    // formData.push({ name: 'id', value: variant2_id });
    // formData.push({ name: 'option-1', value: option_name });
    updateFormData(formData, 'id', variant2_id); 
    updateFormData(formData, 'option-1', option_name); 

  }
else{
  formData = jQuery('#' + form_id).serializeArray(); 
}
updateFormData(
  formData,
  'properties[Note]',
  'You are purchasing the art print only. The frame shown is for display purposes and is not included.'
);
console.log("formData>>",formData)
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data:jQuery.param(formData),
      dataType: 'json',
      success: function(line_item) {
        if(!line_item){
          return ;
        }
        // console.log("Shopify.onItemAdded(line_item);>>>",line_item)
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            console.log("variant_id>>>",variant_id);
            Shopify.cartPopapForm(variant_id);
          } else {
          	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
         
            
          Shopify.onItemAdded(line_item);
         
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        
        Shopify.onItemAdded(line_item);
        
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id,restricted, variant2_id, option_name ) {
  console.log("variant2_id>>",variant2_id)
  console.log("option_name>>",option_name)
  console.log("restricted>>",restricted)
  console.log("product_id", product_id)
if(restricted == 'true'){
  localStorage.setItem("variant2Id",variant2_id); 
  localStorage.setItem("optionName",option_name);
  localStorage.setItem("restricted",restricted);
}
  else{
     localStorage.setItem("variant2Id",null); 
  localStorage.setItem("optionName",null);
  localStorage.setItem("restricted",restricted);
    
  }
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("data-srcset");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
   // var propPrice = jQuery('#product_current_price').text();
  	//jQuery('.popupimage').attr("src",''+image+'');
  	//jQuery('.productmsg').html(title);
    //jQuery('.pop_current_price').text('"'+ propPrice +'"');
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	//jQuery('.popupimage').attr("src",''+image+'');
	//jQuery('.productmsg').html(title);
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>€{{amount_no_decimals}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length) {
            jQuery(".cart-box-product").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li><a href="' + item.url + '" class="image"><img src="' + item.image + '" alt="Cart product Image"></a><div class="content"><a href="' + item.url + '" class="title">' + item.title + '</a><span class="quantity-price">' + item.quantity + ' x <span class="amount">' + Shopify.formatMoney(item.price, formatMoney) + '</span></span><a href="javascript:void(0);" class="remove" onclick="Shopify.removeItem(' + item.variant_id + ')">×</a></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".cart-box-product").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};